import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './PasswordResetEmailVerify.scss';
import { Spin } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { verifyPasswordResetToken } from 'services/loginService';
import { buildEmailLinkExpiredPath, buildPasswordResetPath } from 'utils/pathBuilder';
import { useSession } from 'context/SessionContext';
import { SessionDTO } from 'types/dto/login';

const PasswordResetEmailVerify: React.FC = () => {
  const { t } = useTranslation('password_reset_verify');
  const [searchParams] = useSearchParams();
  const token = searchParams.get('reset_token');
  const [verifyError, setVerifyError] = useState<unknown>();
  const navigate = useNavigate();
  const { session, setSession } = useSession();

  const verifyResetTokenWithToken = useCallback(
    async (token: string) => {
      try {
        //backend needs to return user's current status, so that we can show 2 different expired page
        const result = await verifyPasswordResetToken(token);
        // console.log('Password reset token verified:', result);
        // Password Reset Token Verify
        if (result.access_token && result.refresh_token) {
          setSession({
            ...session,
            _tk: result.access_token,
            _rt: result.refresh_token,
          } as SessionDTO);

          navigate(buildPasswordResetPath(token));
        }
      } catch (error) {
        console.log('Failed to verify password reset token');
        setVerifyError(error);
        navigate(buildEmailLinkExpiredPath());
      }
    },
    [navigate],
  );

  useEffect(() => {
    if (token) {
      verifyResetTokenWithToken(token);
    }
  }, [token, verifyResetTokenWithToken]);

  return (
    <div className="password-reset-email-verify-container">
      {!verifyError && token ? (
        <div className="password-reset-email-verify-loading">
          <Spin size="large" />
          <div>{t('verifying')}</div>
        </div>
      ) : null}
    </div>
  );
};

export default PasswordResetEmailVerify;
